// extracted by mini-css-extract-plugin
module.exports = {"years":"ux2RS","selected":"_23G-Q"};